import * as React from 'react'
import { formatMoney } from 'utils/money-util'
import { animated, useSpring } from 'react-spring'
import styles from './Amount.sass'

interface AmountProps {
  /**
   * The amount. Will be formatted as money.
   */
  value: number
  /**
   * If `true`, will not use special styles to denote positive or negative numbers.
   */
  neutral?: boolean
}

/**
 * The Amount component.
 */
export function Amount({ neutral = false, value: valueInput }: AmountProps) {
  const { value } = useSpring<{ value: number }>({
    value: valueInput,
  })

  const color = value.to((value) => getColor(value, neutral))

  return (
    <animated.span className={styles.root} style={{ color }}>
      {value.to((n) => formatMoney(n))}
    </animated.span>
  )
}

function getColor(value: number, neutral: boolean) {
  if (neutral) {
    return 'auto'
  }

  if (value < 0) {
    return 'var(--red500)'
  } else if (value > 0) {
    return 'var(--green500)'
  }

  return 'auto'
}
